import { Close, AddCircleRounded } from '@mui/icons-material'
import { TEditAppealTimeSlot, TTimeSlotListItem } from 'feature/appeals/type'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useActions, useThunkDispatch } from 'store/hooks'
import { Button, IconButton } from 'ui'
import { LoaderInCentalPosition } from 'widget'

import { AppealTimeSlot } from '../AppealTimeSlot/AppealTimeSlot'

import style from './EditTimeSlotsForm.module.scss'
type TEditTimeSlotsForm = {
  onSubmit: () => void
  userSelectedSlots: [] | TEditAppealTimeSlot[]
  availableSlotsList: [] | TTimeSlotListItem[]
  isButtonDisabled: boolean
  isButtonLoading: boolean
  setButtonDisabled: React.Dispatch<React.SetStateAction<boolean>>
  onClose: () => void
}

// форма редактирования таймслотов заявки
export const EditTimeSlotsForm = ({
  onSubmit,
  userSelectedSlots,
  availableSlotsList,
  isButtonDisabled,
  isButtonLoading,
  setButtonDisabled,
  onClose,
}: TEditTimeSlotsForm) => {
  const screen = useScreen()
  const thunkDispatch = useThunkDispatch()
  const { watch, handleSubmit, clearErrors } = useFormContext()
  const watchFields = watch()
  const { addTimeSlot, removeTimeSlot } = useActions()

  const addDateInputs = () => {
    thunkDispatch(addTimeSlot)
  }

  const removeDateInputs = (keyToRemove: string | undefined) => {
    if (keyToRemove) thunkDispatch(removeTimeSlot(keyToRemove))

    clearErrors(`time-${keyToRemove}`)
    clearErrors(`date-${keyToRemove}`)
  }

  useEffect(() => {
    const isDateNotValid = userSelectedSlots.some(
      obj => obj.isValidDate === false,
    )

    if (isDateNotValid) {
      setButtonDisabled(true)
      return
    }
    setButtonDisabled(false)
  }, [watchFields, userSelectedSlots])

  return (
    <form className={style.modalAddressEdit} onSubmit={handleSubmit(onSubmit)}>
      <div className={style.formWrapper}>
        <div className={style.orderDateInputs}>
          {!!userSelectedSlots.length &&
            !!availableSlotsList.length &&
            userSelectedSlots.map(dateItem => (
              <div className={style.orderDateInputsWrapper} key={dateItem.key}>
                <AppealTimeSlot
                  timeSlotsList={availableSlotsList}
                  currentTimeSlot={dateItem}
                  setSubmitButtonDisabled={setButtonDisabled}
                />

                {userSelectedSlots.length > 1 &&
                  screen !== ScreenEnum.mobile && (
                    <IconButton
                      onClick={() => removeDateInputs(dateItem.key)}
                      className={style.removeSlotIconBtn}
                    >
                      <Close />
                    </IconButton>
                  )}

                {userSelectedSlots.length > 1 &&
                  screen === ScreenEnum.mobile && (
                    <Button
                      startIcon={<Close />}
                      onClick={() => removeDateInputs(dateItem.key)}
                      className={style.removeSlotBtn}
                    >
                      Удалить
                    </Button>
                  )}
              </div>
            ))}
        </div>
        <Button
          startIcon={<AddCircleRounded />}
          className={style.addDateInputs}
          onClick={addDateInputs}
        >
          Добавить еще
        </Button>
      </div>

      <div className={style.buttonWrapper}>
        <Button variant='contained' type='submit' disabled={isButtonDisabled}>
          {isButtonLoading && <LoaderInCentalPosition />}
          Готово
        </Button>
        <Button
          variant={screen === ScreenEnum.mobile ? 'text' : 'outlined'}
          onClick={onClose}
          className={style.cancelButton}
        >
          Отменить
        </Button>
      </div>
    </form>
  )
}
